import classNames from 'classnames';
import { ElementType, ReactNode } from 'react';
import { IntersectionObserverProps, useInView } from 'react-intersection-observer';
import { attempt } from 'yoso';
import { HeaderPortal } from '~/components/Header/HeaderPortal';
import styles from './HeaderSticky.module.scss';

export type HeaderStickyProps = {
  className?: string;
  children: ReactNode | ((props: any) => ReactNode);
  As?: ElementType;
} & Omit<IntersectionObserverProps, 'children'>;

export const HeaderSticky = ({ className, children, As = 'div', ...props }: HeaderStickyProps) => {
  const { ref, inView, entry } = useInView({
    ...props,
  });
  const over = entry?.rootBounds && entry.boundingClientRect.top < entry.rootBounds.top;
  const sticky = !inView && over;

  return (
    <As className={classNames(styles.root, className)} ref={ref}>
      {sticky ? (
        <HeaderPortal>
          <As className={classNames(styles.root, className, { sticky })}>
            {attempt(children, { sticky })}
          </As>
        </HeaderPortal>
      ) : (
        attempt(children, { sticky })
      )}
    </As>
  );
};
